import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function FunctionalitySet(props) {
  const [functionalities, setFunctionalities] = useState([]);
  const [show, setShow] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [collopsing, setCollapsing] = useState("");
  const [collapsed, setColapsed] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    let _lines = [];
    let itensPerLine = 4;
    let lineItemsCounter = 0;
    let lineItems = [];
    for (let index = 0; index < props.funtionalities.length; index++) {
      if (lineItemsCounter < itensPerLine) {
        //fill the line with items
        lineItems.push(props.funtionalities[index]);
        lineItemsCounter++;
      } else {
        // line is filled
        _lines.push([...lineItems]);
        lineItems = [];
        lineItems.push(props.funtionalities[index]);
        lineItemsCounter = 1;
      }
    }
    // push the remaining itens if any
    if (lineItems.length > 0) {
      for (let index = lineItems.length; index < itensPerLine; index++) {
        lineItems.push({});
      }

      _lines.push([...lineItems]);
    }
    setFunctionalities(_lines);
    // some of the lines have less then 3 items, we need fill it with
    //empty items
  }, [props.funtionalities]);

  function onToggle() {
    if (expanded) {
      setColapsed("collapsed");
      setCollapsing("collapsing");
      setExpanded(false);
      setShow("");
    } else {
      setColapsed("");
      setCollapsing("");
      setExpanded(true);
      setShow("show");
    }
  }
  
  return (
    <div class="accordion-item">
      <h2
        class="accordion-header"
        id={`heading-${props.functionalitySetName.replace(/ /g, "")}`}
      >
        <button
          class={`accordion-button ${collapsed}`}
          type="button"
          aria-expanded={expanded}
          aria-controls={props.functionalitySetName.replace(/ /g, "")}
          onClick={onToggle}
        >
          {t(props.functionalitySetName)}
        </button>
      </h2>
      <div
        id={props.functionalitySetName.replace(/ /g, "")}
        class={`accordion-collapse ${collopsing} ${show}`}
        aria-labelledby={`heading-${props.functionalitySetName.replace(
          / /g,
          ""
        )}`}
        data-bs-parent="#functionalities"
      >
        <div class="accordion-body">
          {functionalities.map((set, index) => {
            return (
              <div className="row" key={index}>
                {set.map((item) => (
                  <div className="col">
                    {Object.keys(item).length > 0 ? (
                      <div
                        className="form-check form-check-inline"
                        key={item.id}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={item.id}
                          checked={item.selected}
                          id={item.name}
                          name={item.name}
                          disabled={item.fromRole}
                          onChange={(event) =>
                            props.changeFunctionality(
                              event,
                              item.id,
                              props.functionalitySetName
                            )
                          }
                        />
                        <label className="form-check-label" htmlFor={item.id}>
                          {t(item.name)}
                        </label>
                      </div>
                    ) : (
                      <div className="col"></div>
                    )}
                  </div>
                ))}
                {}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
